import React from "react";
import {
  Box, Stat, StatLabel, StatNumber, StatHelpText,
  Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverHeader,
  PopoverBody, Portal, HStack, Text,
} from "@chakra-ui/react";

export default function MetricCard({ label, value, helpText, color = "blue.500", breakdown }) {
  const card = (
    <Box
      p={4}
      bg="white"
      borderWidth={1}
      borderRadius="md"
      shadow="sm"
      minW="140px"
      cursor={breakdown ? "pointer" : "default"}
      _hover={breakdown ? { borderColor: color, shadow: "md" } : undefined}
    >
      <Stat>
        <StatLabel fontSize="xs" color="gray.500">{label}</StatLabel>
        <StatNumber fontSize="2xl" color={color}>{value}</StatNumber>
        {helpText && <StatHelpText fontSize="xs">{helpText}</StatHelpText>}
      </Stat>
    </Box>
  );

  if (!breakdown || breakdown.length === 0) return card;

  return (
    <Popover placement="bottom-start" isLazy>
      <PopoverTrigger>{card}</PopoverTrigger>
      <Portal>
        <PopoverContent maxH="320px" overflowY="auto" w="240px">
          <PopoverArrow />
          <PopoverHeader fontSize="xs" fontWeight="semibold" color="gray.600">
            {label} by day
          </PopoverHeader>
          <PopoverBody p={2}>
            {breakdown.map((row) => (
              <HStack key={row.label} justify="space-between" px={2} py={1} fontSize="sm">
                <Text color="gray.700">{row.label}</Text>
                <Text fontWeight="semibold" color={color}>{row.value}</Text>
              </HStack>
            ))}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
